<template>
  <v-row dense>
    <v-col>
      <v-row dense align="center" justify="space-between">
        <v-col cols="auto">
          <v-switch
            v-model="isActiveInternal"
            dense
            class="v-input--reverse font-weight-bold"
            :disabled="disabled"
            @input="handleChange"
          >
            <template #label>
              <span class="text-h5 gray--text">Perto</span>
            </template>
          </v-switch>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-row>
            <v-col class="font-weight-bold text-subtitle-2 gray--text text--lighten-1"> Editar Adição </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-combobox
                v-model="additionClose"
                label="adição"
                dense
                outlined
                hide-details
                :items="additionFacilitators"
                background-color="white"
                :disabled="disabled"
                @input="handleChange"
              />
            </v-col>

            <!-- <v-col> -->
            <!--   <v-combobox -->
            <!--     v-model="additionIntermediary" -->
            <!--     label="Intermediário(Temporariamente indisponível)" -->
            <!--     dense -->
            <!--     outlined -->
            <!--     hide-details -->
            <!--     :items="additionFacilitators" -->
            <!--     background-color="white" -->
            <!--     :disabled="true" -->
            <!--     @input="handleChange" -->
            <!--   /> -->
            <!-- </v-col> -->

            <v-col cols="auto">
              <v-btn @click="applyAddition">
                Aplicar
              </v-btn>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-row>
                <v-col class="text-subtitle-2 gray--text text--lighten-1">
                  Esférico
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  <v-combobox
                    :disabled="!isActive || disabled"
                    v-model="sphericalRightEye"
                    placeholder=" "
                    label="Olho direito"
                    dense
                    outlined
                    hide-details
                    :items="sphericalFacilitators"
                    background-color="white"
                    :menu-props="{ auto: true, maxHeight: 304 }"
                    @input="handleChange"
                  />
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  <v-combobox
                    :disabled="!isActive || disabled"
                    v-model="sphericalLeftEye"
                    placeholder=" "
                    label="Olho esquerdo"
                    dense
                    outlined
                    hide-details
                    :items="sphericalFacilitators"
                    background-color="white"
                    :menu-props="{ auto: true, maxHeight: 304 }"
                    @input="handleChange"
                  />
                </v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row>
                <v-col class="text-subtitle-2 gray--text text--lighten-1">
                  Cilíndrico
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  <v-combobox
                    :disabled="!isActive || disabled"
                    v-model="cylindricalRightEye"
                    placeholder=" "
                    label="Olho direito"
                    dense
                    outlined
                    hide-details
                    :items="cylindricalFacilitators"
                    background-color="white"
                    @input="handleChange"
                  />
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  <v-combobox
                    :disabled="!isActive || disabled"
                    v-model="cylindricalLeftEye"
                    placeholder=" "
                    label="Olho esquerdo"
                    dense
                    outlined
                    hide-details
                    :items="cylindricalFacilitators"
                    background-color="white"
                    @input="handleChange"
                  />
                </v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row>
                <v-col class="text-subtitle-2 gray--text text--lighten-1">
                  Eixo
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  <v-combobox
                    :disabled="!isActive || disabled"
                    v-model="axisRightEye"
                    placeholder=" "
                    label="Olho direito"
                    dense
                    outlined
                    hide-details
                    :items="axisFacilitators"
                    suffix="°"
                    background-color="white"
                    @input="handleChange"
                  />
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  <v-combobox
                    :disabled="!isActive || disabled"
                    v-model="axisLeftEye"
                    placeholder=" "
                    label="Olho esquerdo"
                    dense
                    outlined
                    hide-details
                    :items="axisFacilitators"
                    suffix="°"
                    background-color="white"
                    @input="handleChange"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import SAVE_READING_GLASSES from "@/graphql/glasses_prescription/save_reading_glasses.gql";
import SAVE_READING_GLASSES_ADDITION from "@/graphql/glasses_prescription/save_reading_glasses_addition.gql";

export default {
  name: "GlassesPrescriptionFormReadingGlasses",
  props: {
    attendance: Object,
    isActive: Boolean,
    glassesPrescriptionId: String,
    readingGlasses: Object,
    refreshGlassesPrescription: Function,
    facilitators: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
    handleChange: Function,
    sphericalRightEyeFromDistance: {
      type: String,
      default: ''
    },
    sphericalLeftEyeFromDistance: {
      type: String,
      default: ''
    },
    hasDistanceGlasses: Boolean,
  },
  data() {
    return {
      sphericalLeftEye: "Em branco",
      sphericalRightEye: "Em branco",
      cylindricalLeftEye: "",
      cylindricalRightEye: "",
      axisLeftEye: "",
      axisRightEye: "",
      additionClose: "",
      additionIntermediary: "",
    };
  },
  created: function() {
    this.debouncedSaveReadingGlasses = this.lodash.debounce(this.saveReadingGlasses, 900000);
    this.debouncedSaveReadingGlassesAddition = this.lodash.debounce(
      this.saveReadingGlassesAddition,
      900000
    );
  },
  mounted() {
    this.loadReadingGlasses();
  },
  watch: {
    readingGlasses() {
      this.loadReadingGlasses();
    },
  },
  computed: {
    isActiveInternal: {
      set(e) {
        this.$emit("reading-glasses", e);
      },
      get() {
        return this.isActive;
      },
    },
    sphericalFacilitators() {
      let facilitator = this.lodash.find(this.facilitators, { facilitatorType: "spherical" });
      if (facilitator) {
        return facilitator.values;
      }

      return [];
    },
    cylindricalFacilitators() {
      let facilitator = this.lodash.find(this.facilitators, {
        facilitatorType: "cylindrical",
      });
      if (facilitator) {
        return facilitator.values;
      }

      return [];
    },
    axisFacilitators() {
      let facilitator = this.lodash.find(this.facilitators, { facilitatorType: "axis" });
      if (facilitator) {
        return facilitator.values;
      }

      return [];
    },
    additionFacilitators() {
      let facilitator = this.lodash.find(this.facilitators, { facilitatorType: "addition" });
      if (facilitator) {
        return facilitator.values;
      }

      return [];
    },
  },

  methods: {
    loadReadingGlasses() {
      if (this.readingGlasses) {
        this.sphericalLeftEye = this.readingGlasses.sphericalLeftEye;
        this.sphericalRightEye = this.readingGlasses.sphericalRightEye;
        this.cylindricalLeftEye = this.readingGlasses.cylindricalLeftEye;
        this.cylindricalRightEye = this.readingGlasses.cylindricalRightEye;
        this.axisLeftEye = this.readingGlasses.axisLeftEye;
        this.axisRightEye = this.readingGlasses.axisRightEye;

        this.additionClose = this.readingGlasses.additionClose;
        this.additionIntermediary = this.readingGlasses.additionIntermediary;
      }
    },

    async saveReadingGlasses() {
      try {
        if (this.disabled) return;

        await this.apolloMutate({
          mutation: SAVE_READING_GLASSES,
          variables: {
            glassesPrescriptionId: this.glassesPrescriptionId,
            sphericalLeftEye: this.sphericalLeftEye,
            sphericalRightEye: this.sphericalRightEye,
            cylindricalLeftEye: this.cylindricalLeftEye,
            cylindricalRightEye: this.cylindricalRightEye,
            axisLeftEye: this.axisLeftEye,
            axisRightEye: this.axisRightEye,
          },
        })
      } catch (error) {
        console.error('Erro ao salvar:', error);
      }
    },

    async saveReadingGlassesAddition() {
      try {
        if (this.disabled) return;

        await this.apolloMutate({
          mutation: SAVE_READING_GLASSES_ADDITION,
          variables: {
            glassesPrescriptionId: this.glassesPrescriptionId,
            additionClose: this.additionClose,
            additionIntermediary: this.additionIntermediary,
            },
        });
      } catch (error) {
        console.error('Erro ao salvar:', error);
      }
    },

    sumValues(...values) {
      let sum = 0;
      for (let value of values) {
        let num = parseFloat(String(value).replace(",","."));
        if (!isNaN(num)) {
          sum += num;
        }
      }
      let formattedSum = sum.toFixed(2);

      if (sum > 0) {
        formattedSum = "+" + formattedSum;
      } else if (sum < 0) {
        formattedSum;
      } else {
        formattedSum = "0";
      }

      return formattedSum.replace(".", ",");
    }, 

    calculateSphericalRightEyeFromDistance(rightEyeElement, readingGlassesSphericalRightEye) {
      if (rightEyeElement == "Em branco" && readingGlassesSphericalRightEye != null && readingGlassesSphericalRightEye != undefined && readingGlassesSphericalRightEye?.includes("+") || readingGlassesSphericalRightEye?.includes("-")) {
        return this.sumValues(readingGlassesSphericalRightEye);
      } else {
        return rightEyeElement;
      }
    },

    calculateSphericalLeftEyeFromDistance(leftEyeElement, readingGlassesSphericalLeftEye) {
      if (leftEyeElement == "Em branco"&& readingGlassesSphericalLeftEye != null && readingGlassesSphericalLeftEye != undefined && readingGlassesSphericalLeftEye?.includes("+") || readingGlassesSphericalLeftEye?.includes("-")) {
        return this.sumValues(readingGlassesSphericalLeftEye);
      } else {
        return leftEyeElement;
      }
    },

    applyAddition() {
      const additionCloseValue = this.sumValues(this.additionClose);
      const currentSphericalRightEyeFromDistance = this.calculateSphericalRightEyeFromDistance(this.sphericalRightEyeFromDistance, this.readingGlasses?.sphericalRightEye);
      const currentSphericalLeftEyeFromDistance = this.calculateSphericalLeftEyeFromDistance(this.sphericalLeftEyeFromDistance, this.readingGlasses?.sphericalLeftEye);

      if (this.hasDistanceGlasses) {
        this.sphericalRightEye = this.sumValues(additionCloseValue, currentSphericalRightEyeFromDistance);
        this.sphericalLeftEye = this.sumValues(additionCloseValue, currentSphericalLeftEyeFromDistance);
      } else {
        this.sphericalRightEye = this.sumValues(additionCloseValue);
        this.sphericalLeftEye = this.sumValues(additionCloseValue);
      }
    } 
  },
};
</script>

<style lang="scss" scoped></style>

